import { useQuery, useQueryClient } from "@tanstack/react-query"
import { getCampoPersonalizadoPrestamo } from "./CampoPersonalizado.service"

export function useGetCampoPersonalizado() {
  const queryClient = useQueryClient()

  const {
    data: campoPersonalizado,
    isLoading: campoPersonalizadoIsLoading,
    error: campoPersonalizadoError,
    refetch: campoPersonalizadoRefetch,
  } = useQuery({
    queryKey: ["campoPersonalizado"],
    queryFn: () => getCampoPersonalizadoPrestamo(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 2,
    retry: false,
  })
  const campoPersonalizadoInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["campoPersonalizado"] })

  return {
    campoPersonalizado,
    campoPersonalizadoIsLoading,
    campoPersonalizadoError,
    campoPersonalizadoRefetch,
    campoPersonalizadoInvalidation,
  }
}
